<template>
	<div>
		<Header ref="Header" />
		<img :src="menuPic" class="Big-title" />
		<div class="container">
			<div class="topic-list">
				<div v-for="(item,index) in list">
					<div class="topic-list-item row">
						<img @click="articleJump(item)" class="topic-list-pic jump" :src="item.picture" />
						<div class="topic-list-right">
							<div class="service-list-up">
								<div @click="articleJump(item)" class="service-list-title jump">{{item.title}}</div>
								<div class="service-list-text jump" @click="articleJump(item)">{{item.remark}}</div>
							</div>
							<div class="topic-list-line flex">
								<div class="topic-list-time">{{item.createTime}}</div>
								<div class="topic-item-right flex">
									<div class="topic-list-view">浏览 {{item.viewCount}}</div>
									<div @click="articleJump(item)" class="topic-list-btn jump">查看详情</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bar-box">
				<el-pagination
					class="bar-switch"
					background
					layout="prev, pager, next, jumper, total"
					:page-size="searchDate.pageSize"
					:total="Total"
					@current-change="choosePage">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '@/components/header.vue';
	export default {
		components: {
			Header
		},
		data() {
			return {
				menuPic:'',
				bar: 1,
				Total:0,
				searchDate:{
					category:4,
					pageNum:1,
					pageSize:10,
				},
				list:[],
			}
		},
		mounted() {
			this.$refs.Header.setIndex(4);
			// 获取菜单图片
			this.$api.getMenuPic('最新动态').then(res=>{
				console.log(res,'菜单图片');
				this.menuPic=res.data[0].picture;
			})
			this.getDynamicList()
		},
		methods: {
			// 文章链接跳转
			articleJump(item){
				if(item.linkType==1){
					this.$router.push({
						path: 'passage',
						query: {
							index:4,
							id:item.id,
						},
					});
				}else if(item.linkType==2){
					window.open(item.link, '_blank');
				}else{
					return
				}
			},
			// 选择分页
			choosePage(num){
				this.searchDate.pageNum=num;
				this.getDynamicList();
			},
			//获取专题推荐列表
			getDynamicList(){
				this.$api.getArticleList(this.searchDate).then(res=>{
					console.log(res,'最新动态列表');
					this.list=res.rows;
					this.Total=parseInt(res.total);
					// this.pageTotal=Math.ceil(res.total / this.searchDate.pageSize);
				});
			}
		},
	};
</script>

<style scoped>
</style>
